<script setup>
/**
 * A connection role's rank on the org chart (D-344): the other person stands above this one (a
 * functional superior), below it (a functional subordinate), or neither — where a person has no
 * direct superior, a ranked role places them.
 */
defineProps({ modelValue: { type: String, default: null }, disabled: Boolean })
const emit = defineEmits(['update:modelValue'])
</script>

<template>
  <select class="input py-1 text-sm" :value="modelValue || ''" :disabled="disabled" @change="emit('update:modelValue', $event.target.value || null)">
    <option value="">—</option>
    <option value="above">{{ $t('dictionaries.rankAbove') }}</option>
    <option value="below">{{ $t('dictionaries.rankBelow') }}</option>
  </select>
</template>
